import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import PropTypes from "prop-types";

export default function DropdownMenu(props) {
  return (
    <Menu as="div" className="relative">
      {({ open }) => (
        <>
          <div>
            <Menu.Button className="flex text-sm rounded-full focus:outline-none  hover:text-gray-500">
              <span className="sr-only">Open menu</span>
              {props.menuButton}
            </Menu.Button>
          </div>
          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50">
              {props.children}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
}

DropdownMenu.propTypes = {
  menuButton: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
};
